import React from 'react';
import styled from 'styled-components';
import Box from '../../shared/atoms/Box';
import Text from '../../shared/atoms/Text';
import { parseBikeDetails } from '../../../utils/utils';

const QuestionText = styled(Text)`
  color: ${(p) => p.theme.colors.gray.darker};
  font-size: 0.85rem;
  margin-bottom: 2px;
`;

const AnswerText = styled(Text)`
  font-weight: 500;
  white-space: pre-line;
`;

const BikeLabel = styled(Text)`
  font-weight: 600;
  font-size: 0.95rem;
  margin-top: 12px;
  margin-bottom: 4px;
`;

const BikeDetailsDisplay = ({ bikeDetails }) => {
  const parsed = parseBikeDetails(bikeDetails);

  if (!parsed) return null;

  if (parsed.format === 'text') {
    return (
      <Box>
        {parsed.lines.map((line, index) => (
          <Text key={index}>{line}</Text>
        ))}
      </Box>
    );
  }

  const showBikeHeaders = parsed.bikes.length > 1;

  return (
    <Box>
      {parsed.bikes.map((bike, bikeIndex) => (
        <Box key={bikeIndex} mt={bikeIndex > 0 ? 3 : 0}>
          {showBikeHeaders && <BikeLabel>Vélo {bikeIndex + 1}</BikeLabel>}
          {bike.fields.map(({ label, value }, fieldIndex) => (
            <Box key={fieldIndex} mb={2}>
              <QuestionText>{label}</QuestionText>
              <AnswerText>{value}</AnswerText>
            </Box>
          ))}
        </Box>
      ))}
    </Box>
  );
};

export default BikeDetailsDisplay;
